import script from "./LoginPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LoginPage.vue?vue&type=script&setup=true&lang=ts"

import "./LoginPage.vue?vue&type=style&index=0&id=76d0bd7e&lang=css"

const __exports__ = script;

export default __exports__